module.exports = "/_next/static/images/Steve_Sizemore-167b2aff84eb06610af223efcb605b92.webp";